module.exports = __webpack_public_path__ + "static/img/autumn_hetaoPic.30be02c8.png";